<template>
  <div v-if="!walletConnected" class="gate">
    <div class="logo-container">
      <div class="crest">
        <svg viewBox="0 0 32 32" width="54" height="54">
          <path d="M16 2.5 L28 9.2 V22.8 L16 29.5 L4 22.8 V9.2 Z" fill="none" stroke="#d4af37" stroke-width="1.6"/>
          <path d="M16 8 L22 11.5 V18.5 L16 22 L10 18.5 V11.5 Z" fill="#d4af37"/>
        </svg>
      </div>
      <h2>{{ $t('appname') }}</h2>
      <p>{{ $t('homePage.heroSub') }}</p>
    </div>
    <w3m-button v-if="!walletConnected" :label="$t('walletConnected')" :loadingLabel="$t('openWallet')"/>
    <button v-if="walletConnected && !walletLogin" class="login-button" @click="toWalletLogin">{{$t('login')}}</button>
  </div>


  <main v-if="walletConnected">
    <div class="account-info">
      <div class="account-id"><w3m-button :label="$t('walletConnected')" :loadingLabel="$t('openWallet')" size="sm"/></div>
      <div class="info-grid">
        <div class="info-item">
          <div class="label">{{ $t('my.availableFunds') }}</div>
          <div class="value" v-if="!walletLogin">0 USDT</div>
          <div class="value" v-if="walletLogin">{{balance.toFixed(2)}} USDT</div>
        </div>
        <div class="info-item">
          <div class="label">{{ $t('my.team_interest') }}</div>
          <div class="value"  v-if="!walletLogin">0</div>
          <div class="value"  v-if="walletLogin"><span class="team_info">ARP:{{team_arp}}%</span></div>
        </div>
      </div>
    </div>
    <div class="action-list">
      <router-link v-if="walletLogin" to="/withdrawals" class="action-item">
        <div class="icon">↗</div>
        <div class="label">{{ $t('my.withdrawals') }}</div>
        <div class="chevron">›</div>
      </router-link>
      <router-link v-if="walletLogin" to="/deposit" class="action-item">
        <div class="icon">↓</div>
        <div class="label">{{ $t('my.charge') }}</div>
        <div class="chevron">›</div>
      </router-link>
      <router-link v-if="walletLogin" to="/history" class="action-item">
        <div class="icon">☰</div>
        <div class="label">{{ $t('my.bill') }}</div>
        <div class="chevron">›</div>
      </router-link>
      <router-link v-if="walletLogin" to="/team" class="action-item">
        <div class="icon">◇</div>
        <div class="label">{{ $t('my.team') }}</div>
        <div class="chevron">›</div>
      </router-link>
      <router-link v-if="walletLogin" to="/post" class="action-item">
        <div class="icon">ⓘ</div>
        <div class="label">{{ $t('my.announcement') }}</div>
        <div class="chevron">›</div>
      </router-link>
      <button class="tologin-button" v-if="!walletLogin" @click="toWalletLogin">{{ $t('login') }}</button>
    </div>
  </main>
  <div v-if="loading" class="loading-overlay" >
    <div class="loading-spinner"></div>
  </div>


</template>

<script>
import axios from "axios";
import config from '../config';
import { mapState } from 'vuex';
import {getCookie} from "@/utils/cookie";
export default {
  name: 'MyPage',
  data() {
    return {
      loading: false,
    };
  },
  watch: {
  },
  created() {
    if(this.walletLogin){
      axios.get(config.apiHost+'/account', {
        headers: {
          'Content-Type': 'application/json',
          'loginsign':getCookie("signature"),
          'Loginmsg':getCookie("login_msg"),
          'invitefrom':getCookie("invite_from")
        }
      }).then(response => {
        var orderdata = response.data
        if(orderdata.login){
          if(orderdata.ok){
            this.$store.commit('setAccountInfo', orderdata);
          }
        }else{
          this.$store.commit('setLoginOut')
          this.$router.push({ name: "MyPage", params: {} });
        }
      }).catch(error => {
        console.error(error);
      });
    }
  },
  mounted() {
  },
  computed: {
    ...mapState({
      walletConnected: state => state.walletConnected,
      walletLogin: state => state.walletLogin,
      accountAddress: state => state.accountAddress,
      walletConnectModel: state => state.walletConnectModel,
      team_arp: state => state.team_arp,
      balance: state => state.balance,
      level: state => state.level,
      account_info: state => state.account_info,
      showWalletDialog: state => state.showWalletDialog,
    }),
  },
  methods: {
    async toWalletLogin(){
      try {
        this.$store.commit('setShowWalletMsg',this.$t('go_wallet_to_do'));
        await this.$store.dispatch('walletLogin');
        this.$store.commit('setShowWalletMsg',"");
      } catch (error) {
        console.error('Failed to disconnect:', error);
      }
    }
  },
};
</script>

<style scoped>
.account-info {
  background: linear-gradient(145deg, rgba(212, 175, 55, 0.16), #121826 48%);
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 18px;
  border: 1px solid rgba(212, 175, 55, 0.24);
}

.account-id {
  font-size: 1rem;
  margin-bottom: 14px;
  width:100%;
}
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.info-item .label {
  font-size: 0.78rem;
  color: #9aa3b5;
  letter-spacing: 0.06em;
}

.info-item .value {
  font-size: 1.15rem;
  margin-top: 6px;
  color: #3ee0a0;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.action-list {
  background: rgba(16, 22, 35, 0.86);
  border-radius: 18px;
  overflow: hidden;
  width: 100%;
  border: 1px solid rgba(212, 175, 55, 0.16);
}
.action-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  text-decoration: none;
  color:#ffffff;
}

.action-item:last-child {
  border-bottom: none;
}

.action-item .icon {
  width: 28px;
  color: #d4af37;
  font-size: 1rem;
}

.action-item .label {
  flex: 1;
  margin-left: 10px;
}

.action-item .chevron {
  font-size: 1.3rem;
  color: #8d96a8;
}

.gate {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 110px 24px 0;
  text-align: center;
}

.logo-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 28px;
}

.crest {
  width: 84px;
  height: 84px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(212, 175, 55, 0.1);
  border: 1px solid rgba(212, 175, 55, 0.3);
  margin-bottom: 16px;
}

.logo-container h2 {
  font-family: "Cormorant Garamond", serif;
  margin: 0 0 8px;
  letter-spacing: 0.12em;
}

.logo-container p {
  color: #9aa3b5;
  line-height: 1.6;
  margin: 0;
  max-width: 320px;
}

.tologin-button,
.login-button {
  width: 100%;
  display: block;
  padding: 12px;
  background: linear-gradient(180deg, #f3d98a 0%, #c9a227 100%);
  color: #1a1404;
  border: none;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
}

.login-button {
  width: auto;
  padding: 12px 40px;
  margin-top: 16px;
}

.team_info{
  padding-right: 0;
}
</style>
